export type Primitive = (typeof primitives)[number]

export const primitives = ['string', 'integer', 'float'] as const
